import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { readReadingPosition, readingPositionUrl, READING_POSITION_EVENT } from '../utils/readingPosition';
import './ResumeReading.css';

const TYPE_LABELS = { norm: '日本語', ruby: 'ふりがな', en: '英語', gal: 'ギャル訳', hebrew: '原語（ヘブライ語）', greek: '原語（ギリシャ語）' };

export default function ResumeReading() {
  const location = useLocation();
  const [position, setPosition] = useState(readReadingPosition);
  const [dismissed, setDismissed] = useState(false);
  const isBible = /^\/bible(?:\/|$)/.test(location.pathname);

  useEffect(() => {
    const refresh = () => setPosition(readReadingPosition());
    refresh();
    window.addEventListener('storage', refresh);
    window.addEventListener('pageshow', refresh);
    window.addEventListener(READING_POSITION_EVENT, refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('pageshow', refresh);
      window.removeEventListener(READING_POSITION_EVENT, refresh);
    };
  }, [location.pathname]);

  useEffect(() => {
    if (isBible) setDismissed(false);
  }, [isBible]);

  if (isBible || !position || dismissed) return null;

  return (
    <aside className="resume-reading" aria-label="聖書の続きを読む">
      <button className="resume-reading__close" aria-label="続きを読む案内を閉じる" onClick={() => setDismissed(true)}>×</button>
      <p className="resume-reading__caption">前回読んだところ · {TYPE_LABELS[position.type]}</p>
      <p className="resume-reading__reference">{position.bookName} {position.chapter}章{position.verse}節</p>
      <Link className="resume-reading__link" to={readingPositionUrl(position)}>ここから読む <span aria-hidden="true">→</span></Link>
    </aside>
  );
}
